
import { createAction } from 'redux-actions';

import { GET_AGENCIES, FETCH_SUGGEST_AGENCIES } from './constants';

export const getAgencies = createAction(GET_AGENCIES.REQUEST);
export const fetchSuggestAgencies = createAction(FETCH_SUGGEST_AGENCIES.REQUEST);
